module.exports = __webpack_public_path__ + "static/media/placeholder-avatar.2ee3f384.svg";